<template>
    <div>
        <Breadcrumb section-name="Share Holder" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="manage(false)">
                        <div class="fixed-card-height">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="card border-top border-0 border-4 border-primary">
                                        <div class="card-body p-4">
                                            <div class="card-title d-flex align-items-center">
                                                <h5 class="mb-0 text-primary">System Information</h5>
                                            </div>
                                            <hr>
                                            <div class="row g-3">
                                                <div class="col-md-12 form-group">
                                                    <label class="form-label">Project<span class="text-danger">*</span></label>
                                                    <select class="form-control" v-model="addEditParam.project_id" name="project_id">
                                                        <option value="">Select Project</option>
                                                        <option v-for="each in projects" :value="each.id" v-text="each.name"></option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-12 form-group">
                                                    <label class="form-label">Shareholder Type<span class="text-danger">*</span></label>
                                                    <div class="d-flex align-items-center">
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.type" value="shareholder" type="radio" name="type" id="shareholder">
                                                            <label class="form-check-label" for="shareholder">Shareholder</label>
                                                        </div>
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.type" value="investor" type="radio" name="type" id="investor">
                                                            <label class="form-check-label" for="investor">Investor</label>
                                                        </div>
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.type" value="others" type="radio" name="type" id="others">
                                                            <label class="form-check-label" for="others">Others</label>
                                                        </div>
                                                    </div>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-12 form-group">
                                                    <label class="form-label">ID Number<span class="text-danger">*</span></label>
                                                    <input type="text" disabled class="form-control" name="id_number" v-model="addEditParam.id_number">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card border-top border-0 border-4 border-primary">
                                        <div class="card-body p-4">
                                            <div class="card-title d-flex align-items-center">
                                                <h5 class="mb-0 text-primary">Contact Information</h5>
                                            </div>
                                            <hr>
                                            <div class="row g-3">
                                                <div class="col-md-6 form-group">
                                                    <label class="form-label">Active Mobile Number</label>
                                                    <input type="text" class="form-control" name="mobile_number" v-model="addEditParam.mobile_number">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label class="form-label">Family Mobile Number</label>
                                                    <input type="text" class="form-control" autocomplete="new-email" name="family_mobile_number" v-model="addEditParam.family_mobile_number">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label class="form-label">Whatsapp Number</label>
                                                    <input type="text" class="form-control" autocomplete="new-email" name="whatsapp_number" v-model="addEditParam.whatsapp_number">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card border-top border-0 border-4 border-primary">
                                        <div class="card-body p-4">
                                            <div class="card-title d-flex align-items-center">
                                                <h5 class="mb-0 text-primary">Address Information</h5>
                                            </div>
                                            <hr>
                                            <div class="row g-3">
                                                <div class="col-md-12 form-group">
                                                    <label class="form-label">Present Address</label>
                                                    <textarea type="text" class="form-control" name="present_address" v-model="addEditParam.present_address"></textarea>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-12 form-group">
                                                    <label class="form-label">Permanent Address</label>
                                                    <textarea type="text" class="form-control" name="permanent_address" v-model="addEditParam.permanent_address"></textarea>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-8">
                                    <div class="card border-top border-0 border-4 border-primary">
                                        <div class="card-body p-4">
                                            <div class="card-title d-flex align-items-center">
                                                <h5 class="mb-0 text-primary">Personal Information</h5>
                                            </div>
                                            <hr>
                                            <div class="row g-3">
                                                <div class="col-md-12">
                                                    <div class="row mb-4">
                                                        <div class="col-sm-3">
                                                            <template v-if="!photo">
                                                                <input @change="addPhoto" id="fancy-file-upload" type="file"
                                                                       name="files" accept=".jpg, .png, image/jpeg, image/png"
                                                                       class="d-none">
                                                                <label for="fancy-file-upload" class="file-upload avatar">Photo</label>
                                                            </template>
                                                            <template v-if="photo">
                                                                <div class="position-relative w-content">
                                                                    <img class="avatar" :src="photo" alt="">
                                                                    <div class="remove-avatar bg-danger" @click="removePhoto">
                                                                        <i class="bx bx-trash"></i>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div class="col-sm-9">
                                                            <div class="row">
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">Name<span class="text-danger">*</span></label>
                                                                        <input type="text" class="form-control" name="name" v-model="addEditParam.name">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">Father's Name</label>
                                                                        <input type="text" class="form-control" name="father_name" v-model="addEditParam.father_name">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">Mother's Name</label>
                                                                        <input type="text" class="form-control" name="mother_name" v-model="addEditParam.mother_name">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">Spouse Name</label>
                                                                        <input type="text" class="form-control" name="phone" v-model="addEditParam.spouse_name">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-5">
                                                            <template v-if="!signature">
                                                                <input @change="addSignature" id="fancy-sig-upload" type="file"
                                                                       name="files" accept=".jpg, .png, image/jpeg, image/png"
                                                                       class="d-none">
                                                                <label for="fancy-sig-upload" class="file-upload signature">
                                                                    Signature
                                                                </label>
                                                            </template>
                                                            <template v-if="signature">
                                                                <div class="position-relative">
                                                                    <img class="signature" :src="signature" alt="">
                                                                    <div class="remove-sig bg-danger" @click="removeSignature">
                                                                        <i class="bx bx-trash"></i>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div class="col-sm-7">
                                                            <div class="row">
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">Total Share</label>
                                                                        <input type="text" class="form-control" name="total_share" v-model="addEditParam.total_share">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">File Number</label>
                                                                        <input type="text" class="form-control" name="total_share" v-model="addEditParam.file_number">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">NID Number</label>
                                                                        <input type="text" class="form-control" name="nid_number" v-model="addEditParam.nid_number">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="mb-3 form-group">
                                                                        <label class="form-label">TIN Number</label>
                                                                        <input type="text" class="form-control" name="tin_number" v-model="addEditParam.tin_number">
                                                                        <small class="invalid-feedback text-danger"></small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">No Of Children</label>
                                                    <input type="text" class="form-control" name="nationality" v-model="addEditParam.no_of_children">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>

                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Children Details</label>
                                                    <input type="text" class="form-control" name="nationality" v-model="addEditParam.children_details">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Nominee Name</label>
                                                    <input type="text" class="form-control" name="nationality" v-model="addEditParam.nominee_name">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">% Of Share</label>
                                                    <input type="text" class="form-control" name="nationality" v-model="addEditParam.percentage_of_share">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Personal Bank Account Information</label>
                                                    <input type="text" class="form-control" name="nationality" v-model="addEditParam.bank_account_info">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Own Flat In Dhaka</label>
                                                    <input type="text" class="form-control" name="nationality" v-model="addEditParam.own_flat_in_dhaka">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>

                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Nationality</label>
                                                    <input type="text" class="form-control" name="nationality" v-model="addEditParam.nationality">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Hobby</label>
                                                    <input type="text" class="form-control" name="hobby" v-model="addEditParam.hobby">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Occupation</label>
                                                    <input type="text" class="form-control" name="occupation" v-model="addEditParam.occupation">
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Marital Status</label>
                                                    <select class="form-select" v-model="addEditParam.marital_status" name="marital_status">
                                                        <option value="un married">Un Married</option>
                                                        <option value="married">Married</option>
                                                        <option value="divorce">Divorce</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group">
                                                    <label class="form-label">Blood Group</label>
                                                    <select class="form-select" v-model="addEditParam.blood_group" name="blood_group">
                                                        <option value="a+">A+</option>
                                                        <option value="a-">A-</option>
                                                        <option value="b+">B+</option>
                                                        <option value="b-">B-</option>
                                                        <option value="ab+">AB+</option>
                                                        <option value="ab-">AB-</option>
                                                        <option value="o+">O+</option>
                                                        <option value="o-">O-</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-4 form-group position-relative">
                                                    <label class="form-label">Date of Birth</label>
                                                    <flat-pickr class="form-control" v-model="addEditParam.date_of_birth" name="date_of_birth"
                                                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                                    <i class="bx bx-calendar calendar-icon"></i>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>


                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Working Committee Member</label>
                                                    <div class="d-flex align-items-center">
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.working_committee_member" value="1" type="radio" name="working_committee_member" id="working_committee_member_yes">
                                                            <label class="form-check-label" for="working_committee_member_yes">Yes</label>
                                                        </div>
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.working_committee_member" value="0" type="radio" name="working_committee_member" id="working_committee_member_no">
                                                            <label class="form-check-label" for="working_committee_member_no">No</label>
                                                        </div>
                                                    </div>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Purchase Committee Member</label>
                                                    <div class="d-flex align-items-center">
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.purchase_committee_member" value="1" type="radio" name="purchase_committee_member" id="purchase_committee_member_yes">
                                                            <label class="form-check-label" for="purchase_committee_member_yes">Yes</label>
                                                        </div>
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.purchase_committee_member" value="0" type="radio" name="purchase_committee_member" id="purchase_committee_member_no">
                                                            <label class="form-check-label" for="purchase_committee_member_no">No</label>
                                                        </div>
                                                    </div>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Audit Committee Member</label>
                                                    <div class="d-flex align-items-center">
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.audit_committee_member" value="1" type="radio" name="audit_committee_member" id="audit_committee_member_yes">
                                                            <label class="form-check-label" for="audit_committee_member_yes">Yes</label>
                                                        </div>
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.audit_committee_member" value="0" type="radio" name="audit_committee_member" id="audit_committee_member_no">
                                                            <label class="form-check-label" for="audit_committee_member_no">No</label>
                                                        </div>
                                                    </div>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Project Committee Member</label>
                                                    <div class="d-flex align-items-center">
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.project_committee_member" value="1" type="radio" name="project_committee_member" id="project_committee_member_yes">
                                                            <label class="form-check-label" for="project_committee_member_yes">Yes</label>
                                                        </div>
                                                        <div class="form-check me-4">
                                                            <input class="form-check-input" v-model="addEditParam.project_committee_member" value="0" type="radio" name="project_committee_member" id="project_committee_member_no">
                                                            <label class="form-check-label" for="project_committee_member_no">No</label>
                                                        </div>
                                                    </div>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Designation</label>
                                                    <select class="form-select" v-model="addEditParam.designation_id" name="designation_id">
                                                        <option value="">Select Designation</option>
                                                        <option v-for="d in designations" :value="d.id">{{d.name}}</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">District</label>
                                                    <select class="form-select" v-model="addEditParam.district_id" name="district_id">
                                                        <option value="">Select District</option>
                                                        <option v-for="d in districts" :value="d.id">{{d.name}}</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Area</label>
                                                    <select class="form-select" v-model="addEditParam.area_id" name="area_id">
                                                        <option value="">Select Area</option>
                                                        <option v-for="d in areas" :value="d.id">{{d.area_name}}</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Investor Category</label>
                                                    <select class="form-select" v-model="addEditParam.investor_category_id" name="investor_category_id">
                                                        <option value="">Select Category</option>
                                                        <option v-for="d in categories" :value="d.id">{{d.name}}</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="mb-3 form-group">
                                                        <label class="form-label">Land Purchase Price</label>
                                                        <input type="text" class="form-control" name="land_purchase_price" v-model="addEditParam.land_purchase_price">
                                                        <small class="invalid-feedback text-danger"></small>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="mb-3 form-group">
                                                        <label class="form-label">Land Registration Price</label>
                                                        <input type="text" class="form-control" name="land_registration_price" v-model="addEditParam.land_registration_price">
                                                        <small class="invalid-feedback text-danger"></small>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="mb-3 form-group">
                                                        <label class="form-label">Booking Money</label>
                                                        <input type="text" class="form-control" name="booking_money" v-model="addEditParam.booking_money">
                                                        <small class="invalid-feedback text-danger"></small>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 form-group position-relative">
                                                    <label class="form-label">Land Purchase Date</label>
                                                    <flat-pickr class="form-control" v-model="addEditParam.land_purchase_date" name="date_of_birth"
                                                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                                    <i class="bx bx-calendar calendar-icon"></i>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group position-relative">
                                                    <label class="form-label">Land Booking Date</label>
                                                    <flat-pickr class="form-control" v-model="addEditParam.land_booking_date" name="date_of_birth"
                                                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                                    <i class="bx bx-calendar calendar-icon"></i>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group position-relative">
                                                    <label class="form-label">File Opening Date</label>
                                                    <flat-pickr class="form-control" v-model="addEditParam.file_opening_date" name="date_of_birth"
                                                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                                    <i class="bx bx-calendar calendar-icon"></i>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Customer Reference</label>
                                                    <select class="form-select" v-model="addEditParam.customer_reference_id" name="customer_reference_id">
                                                        <option value="">---Select---</option>
                                                        <option v-for="d in customerReferences" :value="d.id">{{d.name}}</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="form-label">Sales Person</label>
                                                    <select class="form-select" v-model="addEditParam.sales_person_id" name="sales_person_id">
                                                        <option value="">---Select---</option>
                                                        <option v-for="d in salesPersons" :value="d.id">{{d.name}}</option>
                                                    </select>
                                                    <small class="invalid-feedback text-danger"></small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-end">
                            <router-link :to="{name: 'shareholder'}" type="button" class="btn btn-secondary me-2 btn-width" >Close</router-link>
                            <button type="submit" class="btn btn-primary btn-width me-2" v-if="!loading">
                                Save
                            </button>
                            <button type="button" @click="manage(true)" class="btn btn-primary btn-width" v-if="!loading">
                                Save and Add New
                            </button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";
export default {
    components: {Breadcrumb},
    data() {
        return {
            breadCrumb: ['Add'],
            loading: false,
            dataLoading: false,
            addEditParam: {
                file_number: '',
                project_id: '',
                type: '',
                id_number: '',
                name: '',
                father_name: '',
                mother_name: '',
                spouse_name: '',
                present_address: '',
                permanent_address: '',
                nid_number: '',
                tin_number: '',
                blood_group: '',
                marital_status: '',
                nationality: '',
                hobby: '',
                occupation: '',
                mobile_number: '',
                family_mobile_number: '',
                whatsapp_number: '',
                total_share: '',
                working_committee_member: 0,
                purchase_committee_member: 0,
                audit_committee_member: 0,
                project_committee_member: 0,
                designation_id: '',
                district_id: '',
                area_id: '',
                investor_category_id: '',
                image: '',
                signature: '',
                land_purchase_price: '',
                land_registration_price: '',
                booking_money: '',
                land_purchase_date: '',
                land_booking_date: '',
                file_opening_date: '',
                customer_reference_id: '',
                sales_person_id:  '',
                no_of_children:  '',
                children_details:  '',
                nominee_name:  '',
                percentage_of_share:  '',
                bank_account_info:  '',
                own_flat_in_dhaka:  '',
            },
            photo: null,
            signature: null,
            designations: [],
            projects: [],
            districts: [],
            categories: [],
            areas: [],
            customerReferences: [],
            salesPersons: []

        }
    },
    watch: {
        'addEditParam.type': function () {
            this.getNextId()
        }
    },
    methods: {
        fetchSalesPerson() {
            ApiService.POST(ApiRoutes.SalesPerson + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.salesPersons = res.data.data;
                }
            });
        },
        fetchCustomerReference() {
            ApiService.POST(ApiRoutes.CustomerReference + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.customerReferences = res.data.data;
                }
            });
        },
        fetchInvestorCategory: function() {
            ApiService.POST(ApiRoutes.InvestorCategory + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.categories = res.data.data;
                }
            });
        },
        fetchArea: function() {
            ApiService.POST(ApiRoutes.ListArea, {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.areas = res.data.data;
                }
            });
        },
        fetchDistrict: function() {
            ApiService.POST(ApiRoutes.District + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.districts = res.data.data;
                }
            });
        },
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        getNextId: function () {
            ApiService.POST(ApiRoutes.ShareHolder + '/lastId', {type: this.addEditParam.type}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam.id_number = res.data
                }
            });
        },
        designationList: function () {
            ApiService.POST(ApiRoutes.ListDesignation, {limit: 5000, page: 1}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.designations = res.data.data
                }
            });
        },
        addPhoto: function (e) {
            this.addEditParam.image = e.target.files[0];
            this.photo = URL.createObjectURL(this.addEditParam.image);
        },
        addSignature: function (e) {
            this.addEditParam.signature = e.target.files[0];
            this.signature = URL.createObjectURL(this.addEditParam.signature);
        },
        removePhoto: function () {
            this.addEditParam.image = '';
            this.photo = null;
        },
        removeSignature: function () {
            this.addEditParam.signature = '';
            this.signature = null;
        },
        manage: function (isNew = false) {
            ApiService.ClearErrorHandler();
            this.loading = true;
            let param = this.makeFormData(this.addEditParam)
            ApiService.POST(ApiRoutes.ShareHolder + '/save', param, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    if (isNew === false) {
                        this.$router.push({
                            name: 'shareholder'
                        })
                    } else {
                        this.$toast.success(res.message)
                        this.addEditParam = {
                            project_id: '',
                            type: '',
                            id_number: '',
                            name: '',
                            father_name: '',
                            mother_name: '',
                            spouse_name: '',
                            present_address: '',
                            permanent_address: '',
                            nid_number: '',
                            tin_number: '',
                            blood_group: '',
                            marital_status: '',
                            nationality: '',
                            hobby: '',
                            occupation: '',
                            mobile_number: '',
                            family_mobile_number: '',
                            whatsapp_number: '',
                            total_share: '',
                            working_committee_member: 0,
                            purchase_committee_member: 0,
                            audit_committee_member: 0,
                            project_committee_member: 0,
                            designation_id: '',
                            district_id: '',
                            area_id: '',
                            investor_category_id: '',
                            image: '',
                            signature: '',
                        }
                    }

                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
    },
    mounted () {
        //this.addNew()
    },
    created() {
        this.designationList();
        this.fetchProject();
        this.fetchDistrict();
        this.fetchArea();
        this.fetchInvestorCategory();
        this.fetchCustomerReference();
        this.fetchSalesPerson();
    }
}
</script>

<style scoped>

</style>
